// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ProjectOverviewDetail  {
    _originalTypeClassName = "Loom.BO.ProjectOverviewDetail";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ProjectOverviewDetail.translate = translateService;
}
this.Id = null;
this.Hours = null;
this.PMs = null;
this.Cost = null;
this.ProjectMonth = null;
this.ProjectMonthDate = null;
this.ProjectMonthTitle = null;
this.Deliverables = null;
this.CostRunningTotal = null;
this.RowTitle = null;
this.BudgetCosts = null;
this.BudgetPMs = null;
this.PMUtilization = null;
this.CostsUtilization = null;
this.PMRunningTotal = null;
this.IsTotal = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Hours:any;
PMs:any;
Cost:any;
ProjectMonth:any;
ProjectMonthDate:any;
ProjectMonthTitle:any;
Deliverables:any;
CostRunningTotal:any;
RowTitle:any;
BudgetCosts:any;
BudgetPMs:any;
PMUtilization:any;
CostsUtilization:any;
PMRunningTotal:any;
IsTotal:any;
WP:any;
ProjectOverview:any;
static setWP = ($this, value) => {
var oldValue = $this.WP;
$this.WP = value;
if (value != null) {
}
}
static setProjectOverview = ($this, value) => {
var oldValue = $this.ProjectOverview;
$this.ProjectOverview = value;
if (value != null) {
if (oldValue != null) {
Domain.ProjectOverview.removeProjectOverviewDetails(oldValue, $this);
}
Domain.ProjectOverview.addProjectOverviewDetails(value, $this);
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}